import { render, staticRenderFns } from "./GroupLocations.vue?vue&type=template&id=f51532b4&scoped=true"
import script from "./GroupLocations.vue?vue&type=script&lang=js"
export * from "./GroupLocations.vue?vue&type=script&lang=js"
import style0 from "./GroupLocations.vue?vue&type=style&index=0&id=f51532b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51532b4",
  null
  
)

export default component.exports